export default function ExemptVatCheckbox({ value, onChange, className, ...props }) {
  return (
    <div className={`flex gap-[5px] items-center ${className}`}>
      <input
        type="checkbox"
        name="exemptVat"
        id="exemptVat"
        value={value}
        onChange={onChange}
        {...props}
      />
      <label htmlFor="exemptVat">Exempt from VAT</label>
    </div>
  );
}
